import { render, staticRenderFns } from "./GoalsPage.vue?vue&type=template&id=c494bde6&scoped=true"
import script from "./GoalsPage.vue?vue&type=script&lang=ts"
export * from "./GoalsPage.vue?vue&type=script&lang=ts"
import style0 from "./GoalsPage.vue?vue&type=style&index=0&id=c494bde6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c494bde6",
  null
  
)

export default component.exports